<script setup lang="ts">
import EntitySidebarField from '@/modules/Project/Entity/EntitySidebarField.vue'
import EntitySidebarFieldContainer from '@/modules/Project/Entity/EntitySidebarFieldContainer.vue'
import type {
  DeletableFileFieldEmits,
  FieldEmits,
  FieldProps,
  PreviewableFieldFileFieldEmits,
} from '@/modules/Project/Fields/field-types'
import FileCollectionField from '@/modules/Project/Fields/registry/filecollection/FileCollectionField.vue'
import { useProjectContext } from '@/modules/Project/useProjectContext'
import { useResolveProjectRoute } from '@/modules/Project/useResolveProjectRoute'
import { getSubprojectId } from '@/shared/utils/property'
import DarwinButton from '@/uiKit/DarwinButton.vue'
import IconSprite from '@/uiKit/IconSprite.vue'
import { computed } from 'vue'

const props = defineProps<FieldProps<'file_collection'>>()
defineEmits<
  FieldEmits<'file_collection'> & DeletableFileFieldEmits & PreviewableFieldFileFieldEmits
>()

const { workspaceId, projectId } = useProjectContext()

const resolveProjectRoute = useResolveProjectRoute()

const projectRoute = computed(() =>
  resolveProjectRoute({
    workspaceId: workspaceId.value,
    parentEntityId: props.field.entityId,
    parentProjectId: projectId.value,
    projectId: getSubprojectId(props.property),
    parentPropertyId: props.property.id,
  }),
)
</script>

<template>
  <EntitySidebarField
    :field="field"
    :property="property"
  >
    <template #actions>
      <DarwinButton
        :to="projectRoute"
        size="xs"
        variant="transparent"
      >
        <template #leading-icon>
          <IconSprite icon="table" />
        </template>
        Open in table view
      </DarwinButton>
    </template>
    <template #field="{ labelId }">
      <EntitySidebarFieldContainer class="pl-1.5">
        <FileCollectionField
          :property="property"
          :field="field"
          :aria-labelledby="labelId"
          @submit="$emit('submit', $event)"
          @focus="$emit('focus', $event)"
          @blur="$emit('blur', $event)"
          @file:delete="$emit('file:delete', $event)"
          @file:preview="$emit('file:preview', $event)"
        />
      </EntitySidebarFieldContainer>
    </template>
  </EntitySidebarField>
</template>
